import { EXTERNAL_FLOW, HOURLY_FLOW, MONTHLY_FLOW } from './constants'

export const getCurrentLink = airport => {
    if (airport.type === EXTERNAL_FLOW) {
        return airport.url
    }
    if (airport.type === HOURLY_FLOW) {
        return `/booking/${airport.location_id}`
    }
    if (airport.type === MONTHLY_FLOW) {
        return `/subscription/${airport.location_id}`
    }
}
